// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-loader {\n  position: absolute;\n  opacity: 1 !important;\n  top: 40%;\n  left: 50%;\n  z-index: 4;\n}\n", ""]);
// Exports
module.exports = exports;
